import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {User} from "../../../models/User/user";
import {Client} from "../../../services/API/client";
import {SessionService} from "../../../services/session.service";
import {toastrService} from "../../../services/ux/toastr.service";
import {UserHttpClientService} from "../../../data/user-http-client.service";
import {debug} from "util";


@Component({
    templateUrl: "./edit-profile.component.html"
})
export class EditProfileComponent implements OnInit {
    // * Made as a var because it is used very often on front
    isAuthorized = false;
    isCompany = false;

    form: FormGroup;

    constructor(
        public session: SessionService,
        private fb: FormBuilder,
        private toastr: toastrService,
        private client: Client,
        private userService: UserHttpClientService
    ) {
        this.form = this.fb.group({
            name: ["", Validators.required],
            surname: ["", Validators.required],
            companyName: ["", Validators.required],
            administratorFirstName: ["",
                Validators.required
            ],
            administratorLastName: [
                "",
                Validators.required
            ],
            email: [
                "", Validators.required
            ],
            cardId: ["", Validators.required],
            nrCel: ["", Validators.required]
        });
    }

    ngOnInit() {
        this.userService.getUserDetails().subscribe((user: User) => {
            this.fillForm(user);
            this.isAuthorized = user.is_authorized;
            this.isCompany = user.is_company;
        });
    }

    private fillForm(user: User) {

        this.form.patchValue({
            email: user.email,
            name: user.first_name,
            surname: user.last_name,
            companyName: user.company_name,
            administratorFirstName: user.administrator_first_name,
            administratorLastName: user.administrator_last_name,
            cardId: user.card_id,
            nrCel: user.phone_number
        });
    }

    onUserDataChange() {
        this.userService.updateUserDetails(
            {
                firstName: this.form.value.name,
                lastName: this.form.value.surname,
                companyName: this.form.value.companyName,
                administratorFirstName: this.form.value.administratorFirstName,
                administratorLastName: this.form.value.administratorLastName,
                celNr: this.form.value.nrCel,
                idCard: this.form.value.cardId
            }
        ).subscribe(
            {
                next: () => {
                    this.toastr.success("Profili i azhornua me sukses.");
                },
                error: err => {

                    switch (err.error) {
                        case "not_authorized":
                            this.toastr.warning("Ju nuk mund te ndryhsoni profilin sepse jeni nje profil i autorizuar.");
                            break;
                        default:
                            this.toastr.warning("Ka ndodhur nje problem. Ju lutem provoni perseri.");
                            break;
                    }
                    this.toastr.error(err.error);
                }
            }
        );
    }
}
